export const LOGIN_PATH = '/login';

/** True when an in-app URL is the login page, with or without a query string. */
export function isLoginUrl(url: string | null | undefined): boolean {
  return !!url && url.split(/[?#]/)[0] === LOGIN_PATH;
}

/**
 * Where a sign-in sends the person: the in-app URL it was asked to return to, or home when there is none.
 * The login page is never a destination (card #1413): a session that ends while the login page is open reloads it as
 * /login?ref=/login, and going back there would show the form a second time.
 */
export function afterSignInUrl(returnUrl: string | null | undefined): string {
  return returnUrl && !isLoginUrl(returnUrl) ? returnUrl : '/';
}
